(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuRemoteMgmtController', OnuRemoteMgmtController);

    OnuRemoteMgmtController.$inject = ['$uibModalInstance', 'AlertModalService', 'OnuService', 'idOnu'];

    function OnuRemoteMgmtController($uibModalInstance, AlertModalService, OnuService, idOnu) {

        var vm = this;
        vm.modalMessage = "onuRemoteManagement.waitGenerate";
        vm.modalLink = "";

        // Flag to avoid closing modal when request is running
        vm.requestRunning = false;

        // Form Actions
        vm.init = init;
        vm.reload = reload;
        vm.close = close;
        vm.getOnuCpeMgr = getOnuCpeMgr;
        vm.setLinkCpeMgr = setLinkCpeMgr;

        function init() {
            getOnuCpeMgr();
        }

        function reload() {
            getOnuCpeMgr();
        }

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function getOnuCpeMgr() {
        	OnuService.getOnu(idOnu).then(function(data){
        		console.log(data)
        		if(data.meProfile === 'Default'){
        			if(!data.vendor){
        				AlertModalService.errorWithMsg("onuRemoteManagement.noVendor");
            			vm.close();
            			return;
        			}
        		}
        		OnuService.getOnuCpeMgr(idOnu).then(function (data) {
        			console.log(data)
        			vm.setLinkCpeMgr(data);
        		})
        		.catch(function (error) {
        			AlertModalService.errorWithMsg("onuRemoteManagement.error");
        			vm.close();
        		});
        	})
        }

        function setLinkCpeMgr(data) {
            if (data.firstCreate) {
                vm.modalMessage = "onuRemoteManagement.waitUp";
            } else {
                vm.modalMessage = "onuRemoteManagement.avaiable";
            }
            vm.modalLink = "http://" + data.publicInterfaceIp + ":" + data.httpPort;
        }

    }
})();